<template>
  <div class="duhaicaoSwiper">
    <div style="height: 100%; width: 100%;background-color1: #13e8e6;" v-if="imageData && imageData.length > 0">

      <swiper ref="duhaicaoSwiper" :options="swiperOption" style="height: 100%; width: 98%;">
        <swiper-slide v-for="(item, index) in imageData" :key="item.image + index" >
          <img class="imageBox1" :src=" item.image" style="height: 100%;" @click="handlePictureCardPreview(item.image)" />
          <div style="height: 20%;position: absolute;bottom: 0;width: 100%;background-color: rgba(0,0,0,0.6);" @click="handlePictureCardPreview(item.image)">
            <div
              style="height: 100%;width: 96%;display: flex;justify-content: space-between;margin-left: 2%;align-items: center;">
              <div style="text-align: center;font-size: 0.7vw; color: #fff">{{ item.name }}</div>
              <div style="text-align: center;font-size: 0.7vw;  color: #13e8e6;font-weight: 600;">{{ item.type }}</div>
              <!-- <div style="text-align: center;font-size: 0.7vw;  color: #13e8e6;font-weight: 600;">h:{{ h }};w:{{ w }}</div> -->
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <el-dialog :visible.sync="dialogVisible" @close="closeDialogImage" modal-append-to-body append-to-body >
        <div style="position: relative;" class="image_dialog">
          <img width="100%" :src=" dialogImageUrl" alt="" />
       <el-button class="closeButton" style="z-index: 10;"  circle @click="closeDialogImage">
                    <i class="el-icon-close"></i>
                </el-button>

        </div>
       
     </el-dialog>
    <!-- <div @mouseenter="enter" @mouseleave="leave">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div> -->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import CFG from "@/config/config";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    imageData: { type: Array, default: [] }
  },
  data() {
    return {
      urlprefix: CFG.LOTIP,
      dialogImageUrl:'',
        dialogVisible: false, //预览是否可见
        h: 0,
      w: 0,


      swiperOption: {
        // 衔接滑动
        // loop: true,

        // 自动滑动
        autoplay: {
          autoplay: true,
          delay: 3000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          // stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false
        },
        // 切换效果 "coverflow"（3d流）
        // effect: 'coverflow',
        // 设置slider容器能够同时显示的slides数量
        slidesPerView: 5,
        spaceBetween: "2%",
        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        // centeredSlides: true,
        // 设置为true则点击slide会过渡到这个slide。
        slideToClickedSlide: true,
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          // rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          // stretch: 0,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          // depth: 60,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          // modifier: 5,
          // 是否开启slide阴影
          // slideShadows: true
        },
        // 使用前进后退按钮来控制Swiper切换。
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observer: true,
        observeParents: true
      },
    }
  },
  computed: {
    duhaicaoSwiper() {
      // shuSwiper 是要绑定到标签中的ref属性
      return this.$refs.duhaicaoSwiper.$swiper
    }
  },
  mounted() {
    // let that = this
    // window.addEventListener('resize', () => {
    //   console.log(that.duhaicaoSwiper)

    //   this.$nextTick(() => {
    //     that.duhaicaoSwiper.update()
    //     console.log(222)
    //   })
    //   console.log(1111)
    // })
    // setInterval(() => {
    //   this.getH()
    //   this.getW()
    // }, 5000);
  },
  methods: {
    getW() {
      this.w = document.getElementsByClassName('imageBox1')[0].clientWidth
    },

    getH() {
      this.h = document.getElementsByClassName('imageBox1')[0].clientHeight
    },
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    closeDialogImage() {
      this.dialogImageUrl = "";
      this.dialogVisible = false;
    },
    enter() {
      this.duhaicaoSwiper.autoplay.stop()
    },
    leave() {
      this.duhaicaoSwiper.autoplay.start()
    },
  }
}
</script>
<style scoped lang="scss">
 .image_dialog  .closeButton{
    width: 45px;
    height: 45px;
    background-color: rgba(0,0,0,.4) !important;
    font-size: 1.5vw;
    font-weight: 600;
    position: absolute;
    top: 2%;
    right: 2%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
}
 /deep/ .el-dialog__header{
 padding: 0 0 !important;
  }
  /deep/ .el-dialog__body{
    padding: 0 0 !important;
  }
.duhaicaoSwiper {
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  // padding-top: 50px;
  // padding-bottom: 40px;

}

.swiper-button-prev {}

.duhaicaoSwiper /deep/ .swiper-slide {
  width: 18.4% !important;
  // margin-right: 2%;
  position: relative;
}

.duhaicaoSwiper /deep/ .swiper-button-prev,
.swiper-button-next {
  top: 30%;
  size: 0.5vw;
  --swiper-navigation-size: 0.5vw;
  background-color: rgba(31, 45, 61, .11);
  width: 5%;
  height: 28%;
  border-radius: 50%;
  color: #fff;
}

.duhaicaoSwiper .swiper-slide:nth-last-child(1) {
  margin-right: 0% !important;
}</style>